import React from 'react';
import { Box, Flex, Icon, Text, HStack, VStack } from '@chakra-ui/react';
import { FaGlobe, FaStore, FaHandshake, FaQuestionCircle } from 'react-icons/fa';

const CONFIG_CANAL = {
    site: {
        label: 'Vendas do Site',
        descricao: 'E-commerce TAGA',
        icone: FaGlobe,
        accent: '#F68633',
    },
    ml: {
        label: 'Mercado Livre',
        descricao: 'Vendas atribuídas',
        icone: FaStore,
        accent: '#E6B800',
    },
    manual: {
        label: 'Vendas Manuais',
        descricao: 'Inseridas no sistema',
        icone: FaHandshake,
        accent: '#38A169',
    },
    pergunta_ml: {
        label: 'Perguntas ML',
        descricao: 'Respondidas pelo vendedor',
        icone: FaQuestionCircle,
        accent: '#805AD5',
    },
};

const formatarMoeda = (valor) => {
    const numero = Number(valor) || 0;
    return numero.toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
};

const CardCanalComissao = ({ canal, volume, valorBase, valorComissao }) => {
    const cfg = CONFIG_CANAL[canal] || CONFIG_CANAL.ml;

    return (
        <Box
            bg="white"
            borderRadius="xl"
            boxShadow="sm"
            borderWidth="1px"
            borderColor="gray.200"
            borderTopWidth="3px"
            borderTopColor={cfg.accent}
            p={{ base: 4, md: 5 }}
            transition="all 0.2s"
            _hover={{ boxShadow: 'md', transform: 'translateY(-2px)' }}
        >
            <Flex align="flex-start" gap={3} mb={3}>
                <Flex
                    bg={`${cfg.accent}15`}
                    w={12}
                    h={12}
                    borderRadius="lg"
                    align="center"
                    justify="center"
                    flexShrink={0}
                >
                    <Icon as={cfg.icone} color={cfg.accent} boxSize={5} />
                </Flex>
                <VStack align="flex-start" spacing={0} flex="1" minW={0}>
                    <Text fontSize="xs" color="gray.500" fontWeight="semibold" textTransform="uppercase" letterSpacing="wider" noOfLines={1}>
                        {cfg.label}
                    </Text>
                    <Text fontSize="xs" color="gray.400" noOfLines={1}>
                        {cfg.descricao}
                    </Text>
                </VStack>
            </Flex>

            <VStack align="flex-start" spacing={1}>
                <Text fontSize={{ base: 'xl', md: '2xl' }} fontWeight="bold" color="gray.800" lineHeight="short">
                    <Text as="span" fontSize="md" color="gray.500" mr={1}>R$</Text>{formatarMoeda(valorComissao)}
                </Text>
                <HStack spacing={3} fontSize="xs" color="gray.500">
                    <Text>
                        <Text as="span" fontWeight="bold" color="gray.700">{volume}</Text> {volume === 1 ? 'item' : 'itens'}
                    </Text>
                    <Text>•</Text>
                    <Text>
                        Base <Text as="span" fontWeight="bold" color="gray.700">R$ {formatarMoeda(valorBase)}</Text>
                    </Text>
                </HStack>
            </VStack>
        </Box>
    );
};

export default CardCanalComissao;
